import TagService from "../services/TagService";

class TagViewModel {
  constructor() {
    this.tagService = TagService;
    this.onStateChange = null;

    this.state = {
      tags: [],
      filteredTags: [],
      searchQuery: "",
      selectedTags: [],
      isLoading: false,
      error: null,
    };

    this.loadTags();
  }

  notifyStateChange() {
    if (this.onStateChange) {
      this.onStateChange();
    }
  }

  async loadTags() {
    this.setState({ isLoading: true, error: null });

    try {
      const tags = await this.tagService.getAllTags();
      this.setState({
        tags,
        filteredTags: tags,
        isLoading: false,
      });
    } catch (error) {
      this.setState({
        error: "Failed to load tags",
        isLoading: false,
      });
    }
  }

  setState(updates) {
    this.state = { ...this.state, ...updates };
    this.notifyStateChange();
  }

  searchTags(query) {
    this.setState({ searchQuery: query });

    if (!query.trim()) {
      this.setState({ filteredTags: this.state.tags });
      return;
    }

    const filtered = this.tagService.searchTags(query);
    this.setState({ filteredTags: filtered });
  }

  createTag(tagData) {
    console.log('ataa', tagData);
    
    try {
      const newTag = this.tagService.createTag(tagData);
      this.setState({
        tags: [...this.state.tags, newTag],
        filteredTags: this.state.searchQuery
          ? this.tagService.searchTags(this.state.searchQuery)
          : [...this.state.tags, newTag],
      });
      return newTag;
    } catch (error) {
      this.setState({ error: "Failed to create tag" });
      throw error;
    }
  }

  updateTag(id, updates) {
    try {
      const updatedTag = this.tagService.updateTag(id, updates);
      if (updatedTag) {
        const updatedTags = this.state.tags.map((tag) =>
          tag.id === id ? updatedTag : tag
        );
        this.setState({
          tags: updatedTags,
          filteredTags: this.state.searchQuery
            ? this.tagService.searchTags(this.state.searchQuery)
            : updatedTags,
        });
      }
      return updatedTag;
    } catch (error) {
      this.setState({ error: "Failed to update tag" });
      throw error;
    }
  }

  getTagId(tag) {
    if (!tag) return undefined;
    return typeof tag.getId === "function" ? tag.getId() : tag.id;
  }

  async deleteTag(id) {
    this.setState({ error: null });
    try {
      await this.tagService.deleteTag(id);
    } catch (error) {
      this.setState({ error: "Failed to delete tag" });
      throw error;
    }

    const removeTag = (list) =>
      Array.isArray(list)
        ? list.filter((tag) => this.getTagId(tag) !== id)
        : [];

    this.setState({
      tags: removeTag(this.state.tags),
      filteredTags: removeTag(this.state.filteredTags),
      selectedTags: this.state.selectedTags.filter((tagId) => tagId !== id),
    });
    return true;
  }

  selectTag(tagId) {
    const selectedTags = [...this.state.selectedTags];
    const index = selectedTags.indexOf(tagId);

    if (index > -1) {
      selectedTags.splice(index, 1);
    } else {
      selectedTags.push(tagId);
    }

    this.setState({ selectedTags });
  }

  selectAllTags() {
    const allTagIds = this.state.filteredTags.map((tag) => tag.id);
    this.setState({ selectedTags: allTagIds });
  }

  deselectAllTags() {
    this.setState({ selectedTags: [] });
  }

  deleteSelectedTags() {
    try {
      this.state.selectedTags.forEach((tagId) => {
        this.tagService.deleteTag(tagId);
      });

      const updatedTags = this.state.tags.filter(
        (tag) => !this.state.selectedTags.includes(tag.id)
      );

      this.setState({
        tags: updatedTags,
        filteredTags: this.state.searchQuery
          ? this.tagService.searchTags(this.state.searchQuery)
          : updatedTags,
        selectedTags: [],
      });
    } catch (error) {
      this.setState({ error: "Failed to delete selected tags" });
      throw error;
    }
  }

  getTagById(id) {
    return this.tagService.getTagById(id);
  }

  getPopularTags(limit = 10) {
    return this.tagService.getPopularTags(limit);
  }

  updateContactCount(tagId, increment = true) {
    this.tagService.updateContactCount(tagId, increment);
    this.loadTags(); // Reload to get updated counts
  }

  clearError() {
    this.setState({ error: null });
  }

  get selectedCount() {
    return this.state.selectedTags.length;
  }

  get totalCount() {
    return this.state.tags.length;
  }

  get filteredCount() {
    return this.state.filteredTags.length;
  }
}

export default TagViewModel;
